import {
    type ApiResult,
    type BaseParams,
    links,
    type PostParams,
    Request,
    type UserData,
    type UserDataKey,
} from '@app/client';

export async function getUserData(params: BaseParams & { key: UserDataKey }): Promise<ApiResult<UserData | null>> {
    return Request.getRequest<UserData | null>({
        ...params,
        target: links.user().data(params.key),
    });
}

export async function putUserData(
    params: BaseParams & { key: UserDataKey } & PostParams<{ value: unknown }>,
): Promise<ApiResult<UserData>> {
    return Request.putRequest<UserData>({
        ...params,
        target: links.user().data(params.key),
    });
}
